// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__cGFqL","closeButton":"styles_closeButton__PKXud","title":"styles_title__mmo3E","container":"styles_container__0J7Dn"};